import React from "react";
import CountUp from "react-countup";
import SVGRenderer from "../SVGRenderer";
import LazyImage from "components/elements/LazyImage/LazyImage";
import SmartLink from "components/SmartLink";
import Button from "components/elements/Button/Button";

import styles from "./Card.module.scss";

/**
 * Horizontal Card layout with image on one side and content on the other
 *
 * @param {Object} props - Component properties (same as standard Card)
 */
const CardBenefitHorizontal = React.forwardRef(
	({ inView, title, svg, short_desc, desc, cta_text, cta_link, image, image_alt, bg_image, bg_image_alt, bg_color, className = "", theme, count_up, footer }, ref) => {
		return (
			<div
				ref={ref}
				{...(theme ? { "data-bs-theme": theme } : {})}
				style={bg_color && { backgroundColor: bg_color }}
				className={`${styles.CardBenefitHorizontal} card rounded-4 shadow-sm border-0 position-relative overflow-hidden h-100 ${className} ${bg_image && "bg-transparent"}`}>
				<div className="row g-0 h-100 align-items-center">
					{image && (
						<div className="col-2">
							<div className="position-relative h-100">
								<LazyImage
									src={image}
									alt={image_alt || title}
									className="img-fluid rounded-start h-100"
									fill_mode="cover"
								/>
							</div>
						</div>
					)}
					{svg && (
						<div className="col-auto">
							<div className="position-relative h-100 d-flex justify-content-center px-2 p-md-4">
								<SVGRenderer svgString={svg} />
							</div>
						</div>
					)}
					<div className={`col`}>
						<div className="card-body row g-0 align-items-center">
							<div className="col">
								
								{inView && count_up && (
									<CountUp
										className="count-up mb-3"
										end={count_up}
										duration={5}
										separator="."
									/>
								)}
								{title && <h3 className="title fs-5 m-0">{title}</h3>}
								{short_desc && <p className="lead mb-3">{short_desc}</p>}

								{desc && (
									<p
										className="card-text"
										dangerouslySetInnerHTML={{ __html: desc }}></p>
								)}
							</div>
							<div className="col-md-auto align-self-center">
								{cta_text && cta_link && (
									<SmartLink to={cta_link}>
										<Button
											size={"sm"}
											variant={"primary"}
											letterCase="uppercase">
											{cta_text}
										</Button>
									</SmartLink>
								)}
							</div>
						</div>
						{footer && (
                            <div className="card-footer px-5 py-3">
								<small className="text-muted">{footer}</small>
                            </div>
                        )}
					</div>
				</div>
				{bg_image && (
					<img
						src={bg_image}
						alt={bg_image_alt || ""}
						className="position-absolute w-100 h-100"
						style={{
							objectFit: "cover",
							filter: "blur(15px)",
							zIndex: -1,
							top: 0,
							left: 0,
						}}
						aria-hidden="true"
					/>
				)}
			</div>
		);
	}
);

export default CardBenefitHorizontal;
